//

// vendor modules
import React, { Component } from "react"
import PropTypes from "prop-types"

import PlatformSpecificFilter from "app/static/frontend/search-new/containers/Filter/index" // eslint-disable-line
import { filterHasValue } from "shared/search/helperFunctions"

export default class Filter extends Component {
    static propTypes = {
        dataTypeLabel: PropTypes.string,
        displayLabel: PropTypes.string,
        uniqueFilterId: PropTypes.string.isRequired,
        uniqueFlvId: PropTypes.string.isRequired,
        filterGroupIsOpen: PropTypes.bool.isRequired,
        filterKey: PropTypes.string.isRequired,
        updateFilter: PropTypes.func.isRequired,
        presentationComponent: PropTypes.func,
        serialize: PropTypes.func,
        deserialize: PropTypes.func,
        value: PropTypes.any,
        initialValue: PropTypes.any,
        isRegistered: PropTypes.bool.isRequired,
        isProtected: PropTypes.bool,
        isNullable: PropTypes.bool,
        // selected from the search => props.uniqueFlvId slice of the store
        searchFilterTerm: PropTypes.string,
        // from app/static/frontend/search-new/components/FilterGroup/index.js renderFilters
        setFilterGroupContainsSearchFilterTerm: PropTypes.func,
        shouldAlwaysDisplayFilter: PropTypes.bool,
    }

    static defaultProps = {
        isProtected: false,
        isNullable: true,
    }

    componentDidMount() {
        // if it already loaded and has a value, then don't set an initial value.
        if (this.props.initialValue && !filterHasValue(this.props.value)) {
            this.props.updateFilter(this.props.uniqueFilterId, this.props.uniqueFlvId, this.props.initialValue, true)
        }
    }

    shouldComponentUpdate(newProps) {
        return (
            this.props.value !== newProps.value ||
            this.props.filterGroupIsOpen !== newProps.filterGroupIsOpen ||
            this.props.searchFilterTerm !== newProps.searchFilterTerm ||
            this.props.shouldAlwaysDisplayFilter !== newProps.shouldAlwaysDisplayFilter ||
            this.props.dataTypeLabel !== newProps.dataTypeLabel ||
            this.props.displayLabel !== newProps.displayLabel
        )
    }

    componentDidUpdate() {
        // if a value cannot be null,
        if (!filterHasValue(this.props.value) && !this.props.isNullable) {
            this.props.updateFilter(this.props.uniqueFilterId, this.props.uniqueFlvId, this.props.initialValue, true)
        }
    }

    updateFilter = (value) => {
        // If the value published by the filter needs some special serialization
        // logic, this is handled BEFORE the value is published in the store.
        const serializedValue = this.props.serialize
            ? // pass filterKey in so that datePickerGenericFilter can serialize value based on the filterKey
              this.props.serialize(value, this.props.filterKey)
            : value

        const hasValue = filterHasValue(serializedValue)

        return this.props.updateFilter(this.props.uniqueFilterId, this.props.uniqueFlvId, serializedValue, hasValue)
    }

    getComponentValue = () => {
        return this.props.deserialize ? this.props.deserialize(this.props.value) : this.props.value
    }

    render() {
        return (
            <PlatformSpecificFilter
                {...this.props}
                updateFilter={this.updateFilter}
                deserializedValue={this.getComponentValue()}
            />
        )
    }
}
